import styled from 'styled-components';
import {Link} from 'react-router-dom';
import memoji from '../img/memoji.png';
const Nav = () =>{
    return (

        <StyledNav>
            <h1> 
                <Link id="logo" to ="/">
                <div className="icon">
                <img src={memoji} alt="efficient"/>
                </div>
                </Link> 
            </h1>

            <ul>
                <li>
                    <Link to ="/"> About Me </Link>
                </li>

                <li>
                    <Link to ="/datascience"> Data Science & Software Work </Link>
                </li>

                <li>
                    <Link to ="/productmanagement"> Product Management Work </Link>
                </li>
            </ul>

        </StyledNav>

        
    )


}
const StyledNav = styled.div`
min-height:8vh;
display:flex;
margin:auto;
justify-content:space-between;
align-items:center;
padding: 0rem 5rem;
background-color:#353434;
position:sticky;
top:0;
z-index:10;

#logo{
img{
    
    width: 15%;
    height:2%;
    padding: 0;
}    
}

a{
    color:white;
    text-decoration:none;
}

ul{
    display: flex;
    list-style: none;
    
}
li{
    padding:0rem 2rem;
}
@media (max-width:1020px){
    
     flex-direction:column;
     padding:2rem 1rem;
     #logo{
         width:20%;
        img{
    
    width: 15%;
    height:5%;
}   
    
        
     }
     ul{
         padding:2rem;
         /* padding-top:4rem; */
         justify-content:space-around;
         width:100%;
     }
     li{
         padding:0;
     }
 }

`



export default Nav;